import { render, staticRenderFns } from "./lkuItemGroup.vue?vue&type=template&id=d05cae12"
import script from "./lkuItemGroup.vue?vue&type=script&lang=js"
export * from "./lkuItemGroup.vue?vue&type=script&lang=js"
import style0 from "./lkuItemGroup.vue?vue&type=style&index=0&id=d05cae12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports